/**
 * Apply-moment declutter helpers (PR6 of the apply-funnel plan).
 *
 * `apply-moment-simplified` is the SOLE switch (read client-side with
 * `useFeatureFlagEnabled`); this module only holds the key and the pure copy
 * rules so they can be unit tested without a DOM.
 */
export const APPLY_MOMENT_SIMPLIFIED_FLAG = "apply-moment-simplified";

/** Honest social proof: never shown below this many REAL outbound clicks. */
export const APPLY_CLICKS_PROOF_MIN = 5;

/**
 * "N job seekers already clicked apply", from the real `jobs.apply_clicks`
 * column. Returns null below the threshold or for a missing/invalid count —
 * never estimates, rounds up, or pads.
 */
export function applyClicksProof(
	applyClicks: number | null | undefined,
	locale: string,
): string | null {
	if (
		typeof applyClicks !== "number" ||
		!Number.isFinite(applyClicks) ||
		applyClicks < APPLY_CLICKS_PROOF_MIN
	) {
		return null;
	}
	const n = Math.floor(applyClicks);
	return locale === "id"
		? `${n} pencari kerja sudah klik lamar`
		: `${n} job seekers already clicked apply`;
}
